var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTamperingActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2078_94315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.875 52.4995C47.3723 52.4995 47.8492 52.302 48.2008 51.9503C48.5525 51.5987 48.75 51.1218 48.75 50.6245V20.6245L35.625 7.49951H30H24.375",
    stroke: "#FBBF00",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 52.4995C12.6277 52.4995 12.1508 52.302 11.7992 51.9503C11.4475 51.5987 11.25 51.1218 11.25 50.6245V9.37451C11.25 8.87723 11.4475 8.40032 11.7992 8.04869C12.1508 7.69706 12.6277 7.49951 13.125 7.49951H18.6",
    stroke: "#00C7EB",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 52.4995H25.7812",
    stroke: "#26BC96",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2078_94315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0766 19.2979L36.9516 6.17295C36.7773 5.99889 36.5705 5.86086 36.3428 5.76676C36.1152 5.67265 35.8713 5.62432 35.625 5.62451H13.125C12.1304 5.62451 11.1766 6.0196 10.4733 6.72286C9.77009 7.42612 9.375 8.37995 9.375 9.37451V50.6245C9.375 51.6191 9.77009 52.5729 10.4733 53.2762C11.1766 53.9794 12.1304 54.3745 13.125 54.3745H46.875C47.8696 54.3745 48.8234 53.9794 49.5266 53.2762C50.2299 52.5729 50.625 51.6191 50.625 50.6245V41V34L41.75 36L35.625 46.5L40.25 35L50.625 30.5V28.5V20.6245C50.6252 20.3782 50.5769 20.1343 50.4828 19.9067C50.3887 19.6791 50.2506 19.4722 50.0766 19.2979ZM35.625 20.6245V10.312L45.9375 20.6245H35.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2078_94315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2078_94315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white",
    transform: "translate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTamperingActive);
export default __webpack_public_path__ + "static/media/TamperingActive.67431a34c1ee1ee97baf021af8386c4f.svg";
export { ForwardRef as ReactComponent };